import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Button,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  Nav, NavItem,
  TabContent, TabPane,
  Spinner,
} from 'reactstrap';
import { NavLink } from 'react-router-dom';
import {
  Colxx,
  Separator,
} from '../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../helpers/AxiosAPI';
import { gAPI_QuickReplies_listByGroup,  gAPI_Twilio_Templates,  gAPI_Internal_Property_By_Id,} from '../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import ReplyListItem from './components/ReplyListItem';
import AddNewReply from './components/AddNewReply';
import classnames from 'classnames';
import no_replytemplate from '../../../../assets/no_replytemplate.png';

const CHANNELS = [
  { key: 'chat', label: 'Chat' },
  { key: 'email', label: 'Email' },
  { key: 'whatsapp', label: 'WhatsApp' },
  { key: 'sms', label: 'SMS' },
];

const TableHeader = () => (
  <div
    className="d-flex align-items-center px-3 py-2"
    style={{
      fontSize: 13,
      color: '#8A8A8A',
      borderBottom: '1px solid #F0F0F0',
      fontWeight: 500,
    }}
  >
    <div style={{ flex: 3, fontWeight: 'Bold' }}>Template Name</div>
    <div style={{ flex: 4, fontWeight: 'Bold' }}>Template Body</div>
    <div style={{ flex: 2, fontWeight: 'Bold' }}>Template ID</div>
    <div style={{ width: 90, fontWeight: 'Bold' }}>Type</div>
    <div style={{ width: 90, fontWeight: 'Bold', textAlign: 'right', paddingRight: 10 }}>
      Action
    </div>
  </div>
);

function Index({ propertyId, locale, groupId }) {

  const [replyList, setReplyList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [activeTab, setActiveTab] = useState('chat');

  const [templateList, setTemplateList] = useState([]);
  const [selectedReplyId, setSelectedReplyId] = useState(null);
  const [editType, setEditType] = useState(null);

  const [isChatbot, setIsChatbot] = useState(false);
  const [isSocial, setIsSocial] = useState(false);
  const [isGuestMessaging, setIsGuestMessaging] = useState(false);
  const [isEmail, setIsEmail] = useState(false);

  useEffect(() => {
    LoadData();

    AxiosAPI({
      method: 'get',
      url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
    })
      .then((res) => {
        const data = res.data;
        console.log(1234, data)
        setIsSocial(data.isSocialChannel || false);
        setIsGuestMessaging(data.isGuestMessaging || false);
        setIsChatbot(data.isBmb || false);
        setIsEmail(data.isEmailAutomation || false);
      })
      .catch((err) => console.error(err));
  }, [propertyId]);

  // Fetch replies + templates
  const LoadData = async () => {
    setLoading(true);
    try {
      const [replyRes, templateRes] = await Promise.all([
        AxiosAPI({
          method: 'get',
          url: `${gAPI_QuickReplies_listByGroup}?groupId=${groupId}&languageCode=${locale}`,
        }),
        AxiosAPI({
          method: 'get',
          url: `${gAPI_Twilio_Templates}?group_id=${groupId}&property_id=${propertyId}`,
        }),
      ]);

      setReplyList(replyRes.data || []);
      setTemplateList(
        (templateRes.data || []).map(item => ({
          ...item,
          // Normalize channel for filtering
          channel: (
            Array.isArray(item.channel)
              ? item.channel
              : (item.channel || item.templateChannel || "").split(",")
          )
            .filter(Boolean)
            .map(c => c.toLowerCase())[0] || "",
        }))
      );
    } catch (e) {
      console.error(e);
    }
    setLoading(false);
  };

  const toggleModal = () => setVisible(!visible);

  // Switch active tab
  const toggleMenu = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  // Filter data by channel
  const getDataByChannel = (channelKey, list = []) => {
    return list.filter((item) => {
      let channels = [];
      if (item.templateChannel) {
        channels = Array.isArray(item.templateChannel)
          ? item.templateChannel
          : item.templateChannel.toString().split(",");
      } else if (item.channel) {
        channels = Array.isArray(item.channel)
          ? item.channel
          : item.channel.toString().split(",");
      }
      return channels
        .map(c => c?.toLowerCase().trim())
        .includes(channelKey.toLowerCase());
    });
  };

  // EDIT HANDLERS
  const handleEditTemplate = (template) => {
    setSelectedReplyId(template.id);
    setEditType('template');
    setVisible(true);
  };

  const handleEditReply = (item) => {
    setSelectedReplyId(item.id);
    setEditType('reply');
    setVisible(true);
  };

  const handleAddNew = () => {
    setSelectedReplyId(null);
    setEditType(null);
    setVisible(true);
  };

  if (loading) return <div className="loading" />;

  return (
    <Fragment>
      <div className="pt-3">

        {/* Page header */}
        <div className="d-flex justify-content-start align-items-center mb-3"
          style={{ borderBottom: '1px solid #eee', paddingBottom: 10, gap: 12 }}
        >
          <h5 style={{ margin: 0, color: 'var(--theme-color-1)', fontWeight: 600 }}>
            Live Chat Shortcuts
          </h5>
          <Button color="primary" size="xs" outline onClick={handleAddNew}>
            + Add New
          </Button>
        </div>

        {/* Channel tabs */}
        <Nav tabs className="card-header-tabs separator-tabs ml-1 mb-3">
          {isChatbot && (
            <NavItem>
              <span
                className={classnames('nav-link', { active: activeTab === 'chat' })}
                style={{ cursor: 'pointer' }}
                onClick={() => toggleMenu('chat')}
              >
                Chat
              </span>
            </NavItem>
          )}

          {isEmail && (
            <NavItem>
              <span
                className={classnames('nav-link', { active: activeTab === 'email' })}
                style={{ cursor: 'pointer' }}
                onClick={() => toggleMenu('email')}
              >
                Email
              </span>
            </NavItem>
          )}

          {(isSocial || isGuestMessaging) && (
            <>
              <NavItem>
                <span
                  className={classnames('nav-link', { active: activeTab === 'whatsapp' })}
                  style={{ cursor: 'pointer' }}
                  onClick={() => toggleMenu('whatsapp')}
                >
                  WhatsApp
                </span>
              </NavItem>
              <NavItem>
                <span
                  className={classnames('nav-link', { active: activeTab === 'sms' })}
                  style={{ cursor: 'pointer' }}
                  onClick={() => toggleMenu('sms')}
                >
                  SMS
                </span>
              </NavItem>
            </>
          )}
        </Nav>

        <TabContent activeTab={activeTab}>
          <TabPane tabId="chat">
            {(() => {
              const chatData = getDataByChannel('chat', replyList);
              return chatData.length === 0 ? (
                <div className="mb-4 text-center">
                  <img className="w-30" style={{ marginTop: '5rem' }} src={no_replytemplate} />
                </div>
              ) : (
                <>
                  <TableHeader />
                  {chatData.map((item, index) => (
                    <ReplyListItem
                      key={`chat_${index}`}
                      item={item}
                      LoadData={LoadData}
                      type="chat"
                      index={index}
                      onEdit={handleEditReply}
                    />
                  ))}
                </>
              );
            })()}
          </TabPane>

          <TabPane tabId="email">
            {(() => {
              const emailData = getDataByChannel('email', replyList);
              return emailData.length === 0 ? (
                <div className="mb-4 text-center">
                  <img className="w-30" style={{ marginTop: '5rem' }} src={no_replytemplate} />
                </div>
              ) : (
                <>
                  <TableHeader />
                  {emailData.map((item, index) => (
                    <ReplyListItem
                      key={`email_${index}`}
                      item={item}
                      LoadData={LoadData}
                      type="email"
                      index={index}
                      onEdit={handleEditReply}
                    />
                  ))}
                </>
              );
            })()}
          </TabPane>

          <TabPane tabId="whatsapp">
            {(() => {
              const waData = getDataByChannel('whatsapp', templateList);
              return waData.length === 0 ? (
                <div className="mb-4 text-center">
                  <img className="w-30" style={{ marginTop: '5rem' }} src={no_replytemplate} />
                </div>
              ) : (
                <>
                  <TableHeader />
                  {waData.map((template, index) => (
                    <ReplyListItem
                      key={template.id}
                      item={template}
                      type="whatsapp"
                      index={index}
                      onEdit={handleEditTemplate}
                    />
                  ))}
                </>
              );
            })()}
          </TabPane>

          <TabPane tabId="sms">
            {(() => {
              const smsData = getDataByChannel('sms', templateList);
              return smsData.length === 0 ? (
                <div className="mb-4 text-center">
                  <img className="w-30" style={{ marginTop: '5rem' }} src={no_replytemplate} />
                </div>
              ) : (
                <>
                  <TableHeader />
                  {smsData.map((template, index) => (
                    <ReplyListItem
                      key={template.id}
                      item={template}
                      type="sms"
                      index={index}
                      onEdit={handleEditTemplate}
                    />
                  ))}
                </>
              );
            })()}
          </TabPane>
        </TabContent>
      </div>

      <AddNewReply
        toggleModal={toggleModal}
        id={selectedReplyId}
        editType={editType}
        formLabel={selectedReplyId ? 'Edit Template' : 'Create a New Template'}
        visible={visible}
        LoadData={LoadData}
        isChatbot={isChatbot}
        isEmail={isEmail}
        isSocial={isSocial}
        isGuestMessaging={isGuestMessaging}
        defaultChannel={
          (activeTab === 'chat' && isChatbot) ||
            (activeTab === 'email' && isEmail) ||
            ((activeTab === 'whatsapp' || activeTab === 'sms') && (isSocial || isGuestMessaging))
            ? activeTab
            : 'chat'
        }
      />
    </Fragment>
  );
}

const mapStateToProps = ({ settings }) => {
  const { propertyId, locale, groupId } = settings;
  return { propertyId, locale, groupId };
};

export default injectIntl(connect(mapStateToProps, {})(Index));
